import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accountType'
})
export class AccountTypePipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (value == 'C') {
      return 'Checking';
    } else if (value == 'S') {
      return 'Savings';
    }
  }

}
